module.exports = __webpack_public_path__ + "img/T08.90864c51.jpg";